// extracted by mini-css-extract-plugin
export default {"wrapped":"Application_wrapped__JvIC0"};